<template>
  <div class="invoice-record">
    <div class="record-card">
      <div class="my-card-title">团队申请</div>
      <div class="table-wrap">
        <div class="flex-grow mgb10">
          <el-button type="success" size="small" :disabled="multipleSelection.length === 0"
            @click="handleMultiAgree">批量通过</el-button>
          <el-button type="error" size="small" :disabled="multipleSelection.length === 0"
            @click="handleMultiReject">批量驳回</el-button>
        </div>
        <el-table :data="list" v-loading="loading" element-loading-text="给我一点时间" :empty-text="emptyText" border
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" align="center" width="55"></el-table-column>
          <el-table-column label="编号" align="center" width="100" prop="id">
          </el-table-column>
          <el-table-column label="姓名" align="center" minWidth="150">
            <template slot-scope="{row}">
              <div>{{ row.name || '--' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="手机号" align="center" width="150" prop="phone">
          </el-table-column>
          <el-table-column label="状态" align="center" width="150" prop="team_status_name">
          </el-table-column>
          <el-table-column label="申请时间" align="center" width="200" prop="team_apply_time">
          </el-table-column>
          <el-table-column label="操作" align="center" width="100" fixed="right">

            <template slot-scope="{row}">
              <el-link class="colorBlue mgr10" @click="handleSetAgree(row)" :underline="false">同意</el-link>
              <el-link class="colorRed" @click="handleSetReject(row)" :underline="false">驳回</el-link>
            </template>
          </el-table-column>
        </el-table>

        <div class="flex-row mgt20">
          <div class="flex-grow-1"></div>
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.pagesize"
            layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { getApplyList, setApplyAgree, setApplyReject } from "@/api/team";
export default {
  name: 'TeamApply',
  components: {

  },
  data() {
    return {
      loading: true,
      emptyText: '暂无数据',
      listQuery: {
        status: '0',
        page: 1,
        pagesize: 10
      },
      list: [],
      total: 0,
      multipleSelection: [],
    };
  },
  computed: {

  },
  created() {
    this.getList();
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleMultiAgree() {
      const ids = [];
      this.multipleSelection.map((item) => {
        ids.push(item.id);
      });
      if (ids.length > 0) {
        this.loading = true;
        setApplyAgree({
          ids: ids.join(',')
        }).then((response) => {
          this.loading = false;
          this.getList();
          this.$message.success('操作成功!')
        }).catch(() => {
          this.loading = false;
        });

      } else {
        this.$message.error('请选择数据!')
      }
    },
    handleMultiReject() {
      const ids = [];
      this.multipleSelection.map((item) => {
        ids.push(item.id);
      });
      if (ids.length > 0) {
        setApplyReject({
          ids: ids.join(','),
        }).then((response) => {
          this.loading = false;
          this.getList();
          this.$message.success('操作成功!')
        }).catch(() => {
          this.loading = false;
        });
      } else {
        this.$message.error('请选择数据!')
      }
    },
    handleSetAgree(row) {
      this.multipleSelection.push(row)
      this.handleMultiAgree();
    },
    handleSetReject(row) {
      this.multipleSelection.push(row)
      this.handleMultiReject();
    },
    // 获取列表
    getList() {
      this.loading = true;
      const _listQuery = Object.assign({}, this.listQuery);
      getApplyList(_listQuery)
        .then((response) => {
          this.list = response.data.list;
          this.total = response.data.count * 1;
          this.loading = false;
          this.multipleSelection = [];
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 查询
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    // 更改每页行数
    handleSizeChange(val) {
      this.listQuery.pagesize = val;
      this.getList();
    },
    // 更改页码
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
  }
};
</script>

<style lang="scss" scoped>
.invoice-record {
  width: 100%;
  padding: 25px 0 227px 0;

  .record-card {
    background: #FFFFFF;

    .table-wrap {
      padding: 20px 32px;

    }
  }
}
</style>
